module.exports = __webpack_public_path__ + "staticcomp/img/cover.58fd9a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/7/cover.jpg
// module id = Raai
// module chunks = 39